// extracted by mini-css-extract-plugin
module.exports = {"text":"land_text__11GjP","link":"land_link__acwj0","image":"land_image__2SW04"};